import React from "react";
import classNames from "classnames";
import {safeHTML} from "../../utils/safeHTML";
import Link from "next/link";
import styles from "./ReadNow.module.scss";

const ReadNow = React.forwardRef(
  function ReadNow({className, list}, ref) {
    return (
      <section className={classNames(styles.readNow, className)} ref={ref}>
        <h2 className={styles.readNow__title}>Сейчас читают</h2>

        <ul className={styles.readNow__list}>
          {list.map((item, i) =>
            <li key={item?.id ? item.id : i} className={styles.readNow__item}>
              <Link legacyBehavior  href={item.href}  >
                <a className={styles.readNow__link} rel="noreferrer" >
                  {safeHTML(item.title)}
                </a>
              </Link>
            </li>
          )}
        </ul>
      </section>
    );
  });
export default ReadNow;
ReadNow.propTypes = {};

